import "./notFound.css"
import { Component } from "react"


class NotFound extends Component{
  render(){
  return (
  <div className="not-found-card">
    <img className="notFound-image" alt="not Found" src="https://img.freepik.com/free-vector/internet-network-warning-404-error-page-file-found-web-page_1150-48326.jpg?w=2000" />

  </div>)
}
}

export default NotFound
